import { useState, useEffect } from 'react'
import { createCart, updateCart, CartData, ErrorResponse, CartResponse } from '../../service/cart'

const useGetDataFromSupercontrol = (
  data: CartData,
  setData: (data: CartData) => void,
  onError: (msg: string) => void,
  onVoucherError: (msg: string, data: CartData) => CartData,
  onStart: () => void,
  updateContentDefault?: boolean
) => {
  const [ apiResponse, setApiResponse ] = useState<CartResponse>(null)
  const [ fetchData, setFetchData ] = useState<boolean>(true)
  const [ updateContent, setUpdateContent ] = useState<boolean>(updateContentDefault)
  const [ loading, setLoading ] = useState<boolean>(true)

  useEffect(() => {
    const apiFunction = data.ref ? updateCart : createCart
    onStart()

    apiFunction(data, updateContent).then(res => {
      if ('hasError' in res) {
        onError((res as ErrorResponse).details)
      } else {
        const cartResponse = res as CartResponse

        let tmp = { ...data }
        tmp.ref = cartResponse.ref

        if (cartResponse.cart.voucher && !cartResponse.cart.voucher.voucher_id) {
          tmp = onVoucherError('Invalid voucher code', tmp)
        } else {
          setApiResponse(cartResponse)
        }

        setData(tmp)
      }
      setLoading(false)
    })
  }, [ fetchData ])

  return {
    apiResponse,
    loading,
    setLoading,
    fetchData: (updateContent: boolean) => {
      setUpdateContent(updateContent)
      setFetchData(!fetchData)
    }
  }
}

export default useGetDataFromSupercontrol

